/**
 * Character model
 */

import { Action, SetupActionData } from './Action';
import { CustomProperty, SetupCustomPropertyData } from './CustomProperty';
import { RagsObject } from './Object';

// Forward declaration
declare function ArrayCloneForDiff(arr: any[]): any[];
declare var VoidRoomGuid: string;

export class Character {
    Charname: string = "";
    CharnameOverride: string = "";
    Inventory: RagsObject[] = [];
    Actions: Action[] = [];
    CharGender: string = "Other";
    CurrentRoom: string = "";
    Description: string = "";
    CharPortrait: string = "";
    bEnterFirstTime: boolean = false;
    bLeaveFirstTime: boolean = false;
    bAllowInventoryInteraction: boolean = false;
    CustomProperties: CustomProperty[] = [];
    ActionsUseAdvanced: boolean = false;

    cloneForDiff(): {
        Charname: string;
        CharnameOverride: string;
        Actions: any[];
        CharGender: string;
        CurrentRoom: string;
        Description: string;
        CharPortrait: string;
        bEnterFirstTime: boolean;
        bLeaveFirstTime: boolean;
        bAllowInventoryInteraction: boolean;
        CustomProperties: any[];
    } {
        return {
            Charname: this.Charname,
            CharnameOverride: this.CharnameOverride,
            Actions: (window as any).ArrayCloneForDiff?.(this.Actions) || this.Actions.slice(),
            CharGender: this.CharGender,
            CurrentRoom: this.CurrentRoom,
            Description: this.Description,
            CharPortrait: this.CharPortrait,
            bEnterFirstTime: this.bEnterFirstTime,
            bLeaveFirstTime: this.bLeaveFirstTime,
            bAllowInventoryInteraction: this.bAllowInventoryInteraction,
            CustomProperties: (window as any).ArrayCloneForDiff?.(this.CustomProperties) || this.CustomProperties.slice(),
        };
    }
}

export function SetupCharacterData(GameData: any[]): Character {
    const TheCharacter = new Character();
    TheCharacter.Charname = GameData[0];
    TheCharacter.CharnameOverride = GameData[1];
    TheCharacter.Description = GameData[2];
    TheCharacter.CharGender = GameData[3];
    TheCharacter.CurrentRoom = GameData[4];
    TheCharacter.bAllowInventoryInteraction = GameData[5];
    TheCharacter.CharPortrait = GameData[6];

    for (let i = 0; i < GameData[7].length; i++) {
        TheCharacter.CustomProperties.push(SetupCustomPropertyData(GameData[7][i]));
    }

    for (let j = 0; j < GameData[8].length; j++) {
        TheCharacter.Actions.push(SetupActionData(GameData[8][j]));
    }

    TheCharacter.ActionsUseAdvanced = Boolean(GameData[9]);
    return TheCharacter;
}

/**
 * Convert character to string representation
 */
export function CharToString(thechar: Character): string {
    if (thechar.CharnameOverride == "")
        return thechar.Charname;
    else
        return (window as any).PerformTextReplacements?.(thechar.CharnameOverride, null) || thechar.CharnameOverride;
}
